import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import debounce from 'lodash.debounce'
import { Box3, Vector3 } from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import SceneEditor from './sceneEditor'
import MobileDetect from 'mobile-detect';
import "./style.css"

/**
 * Base
 */
// Debug

// Canvas
const canvas = document.querySelector('canvas.webgl')

const is_mobile = new MobileDetect().phone() ? '#phone-controller' : '#controller';

const loading_div = document.querySelector('.loading_container')

// Scene
const scene = new THREE.Scene()

scene.background = new THREE.Color( "#202020" );

/**
 * Models
 */


const progressBar = document.querySelector('.progress-bar');
const progressBarText = document.querySelector('.progress-bar__text');
let state;
const loadingManager = new THREE.LoadingManager(
    // Loaded
    () =>
    {
    },

    // Progress
    (itemUrl, itemsLoaded, itemsTotal) =>
    {
        // Calculate the progress and update the loadingBarElement
               
        state = Math.round(itemsLoaded / itemsTotal * 100)

        if (itemsTotal !== 0){
            progressBar.style.left = `-${100 - state}%`;
            progressBarText.textContent =  `${state}%`;
        }
    }
)
const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('/Data/draco/')

const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)

let focusOnWindow = false;

const modelInfo = JSON.parse(document.getElementById("data").text);

const load_model = (data) => {
    if (data.data_type === 'custom') {
        const group = new THREE.Group();
        const meshes_promises = [];
        Object.entries(data.geometry).forEach(([key, value]) => {
            const mesh_promise = new Promise((resolve, reject) => {
                dracoLoader.load(
                    value.url,
                    ( geometry ) => {
                        const material = new THREE.MeshStandardMaterial( { color: value.color, transparent: true, opacity: 0.5, side: THREE.DoubleSide } );
                        const mesh = new THREE.Mesh( geometry, material );
                        mesh.name = value.name;
                        // mesh.control_id = key;
                        group.add( mesh );
                        resolve([key, mesh]);
                    }
                );
            });
            meshes_promises.push(mesh_promise);
          });

        Promise.all(meshes_promises).then((values) => {
            const editor_structure = [];
            values.forEach((val)=> {
                const key = val[0];
                const mesh = val[1];
                const key_split = key.split('_');
                if (key_split.length === 2) {
                    editor_structure.push({
                        id: key,
                        name: mesh.name,
                        mesh: mesh,
                        sections: []
                    })
                } else if (key_split.length === 6) {
                    const mesh_id = key_split[0] + '_' + key_split[1];
                    const mesh_element = editor_structure.find((element) => element.id === mesh_id);
                    const section_id = key_split[0] + '_' + key_split[1] + '_' + key_split[2] + '_' + key_split[3];
                    let section = mesh_element.sections.find((element) => element.id === section_id);
                    if (section) {

                    } else {
                        section = {
                            id: section_id,
                            name: key_split[2] + ' ' + key_split[3],
                            tracks: []
                        }
                        mesh_element.sections.push(section);
                        const track_id = key_split[0] + '_' + key_split[1] + '_' + key_split[2] + '_' + key_split[3] + '_' + key_split[4] + '_' + key_split[5];
                        section.tracks.push({
                            id: track_id,
                            name: key_split[4] + ' ' + key_split[5],
                            mesh: mesh
                        })
                    }
                }
            })
            loading_div.remove();
            canvas.style.display = 'block';
            scene.add(group);
            const box = new Box3().setFromObject(group);
            const model_size = box.getSize(new Vector3()).length();
            const center = box.getCenter(new Vector3());
            group.position.x += (group.position.x - center.x);
            group.position.y += (group.position.y - center.y);
            group.position.z += (group.position.z - center.z);
            camera.far = model_size * 100;
            camera.updateProjectionMatrix();
            camera.position.copy(center);
            camera.position.x += model_size / 2.0;
            camera.position.y += model_size / 5.0;
            camera.position.z += model_size / 2.0;
            camera.lookAt(0, 0, 0);
            SceneEditor.renderEditor(scene, document.querySelector(is_mobile), 'custom', editor_structure)
            sizes.width = webgl_wrapper.clientWidth
            sizes.height = webgl_wrapper.clientHeight
            renderer.setSize(sizes.width, sizes.height)
            renderer.render(scene, camera)
        });
    } else if (data.data_type === 'glb') {
        gltfLoader.load(
            data.file_url,
            (gltf) =>
            {
                gltf.scene.scale.set(0.025, 0.025, 0.025)
                loading_div.remove();
                canvas.style.display = 'block';
                scene.add(gltf.scene)
                const box = new Box3().setFromObject(gltf.scene);
                const model_size = box.getSize(new Vector3()).length();
                const center = box.getCenter(new Vector3());
                gltf.scene.position.x += (gltf.scene.position.x - center.x);
                gltf.scene.position.y += (gltf.scene.position.y - center.y);
                gltf.scene.position.z += (gltf.scene.position.z - center.z);
                camera.far = model_size * 100;
                camera.updateProjectionMatrix();
                camera.position.copy(center);
                camera.position.x += model_size / 2.0;
                camera.position.y += model_size / 5.0;
                camera.position.z += model_size / 2.0;
                camera.lookAt(0, 0, 0);
                SceneEditor.renderEditor(scene, document.querySelector(is_mobile), 'glb')
                sizes.width = webgl_wrapper.clientWidth
                sizes.height = webgl_wrapper.clientHeight
                renderer.setSize(sizes.width, sizes.height)
                renderer.render(scene, camera)
            },
            ( xhr ) => {
                
            },
            (error) => {
                console.log('ошибка');
            }
        )
    }
}

load_model(modelInfo);



/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
scene.add(ambientLight)

const directionalLight1 = new THREE.DirectionalLight(0xffffff, 0.5)
directionalLight1.position.set(0, 100, 0)
scene.add(directionalLight1)
// const directional_light_helper1 = new THREE.DirectionalLightHelper(directionalLight1)
// scene.add(directional_light_helper1)
const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.5)
directionalLight2.position.set(0, -100, 0)
scene.add(directionalLight2)
// const directional_light_helper2 = new THREE.DirectionalLightHelper(directionalLight2)
// scene.add(directional_light_helper2)
const directionalLight3 = new THREE.DirectionalLight(0xffffff, 0.5)
directionalLight3.position.set(100, 0, 0)
scene.add(directionalLight3)
// const directional_light_helper3 = new THREE.DirectionalLightHelper(directionalLight3)
// scene.add(directional_light_helper3)
const directionalLight4 = new THREE.DirectionalLight(0xffffff, 0.5)
directionalLight4.position.set(-100, 0, 0)
scene.add(directionalLight4)
// const directional_light_helper4 = new THREE.DirectionalLightHelper(directionalLight4)
// scene.add(directional_light_helper4)
const directionalLight5 = new THREE.DirectionalLight(0xffffff, 0.5)
directionalLight5.position.set(0, 0, 100)
scene.add(directionalLight5)
// const directional_light_helper5 = new THREE.DirectionalLightHelper(directionalLight5)
// scene.add(directional_light_helper5)
const directionalLight6 = new THREE.DirectionalLight(0xffffff, 0.5)
directionalLight6.position.set(0, 0, -100)
scene.add(directionalLight6)
// const directional_light_helper6 = new THREE.DirectionalLightHelper(directionalLight6)
// scene.add(directional_light_helper6)


/**
 * Sizes
 */
const webgl_wrapper = document.querySelector("#webgl-wrapper");

const sizes = {
    width: webgl_wrapper.clientWidth,
    height: webgl_wrapper.clientHeight
};

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = webgl_wrapper.clientWidth;
    sizes.height = webgl_wrapper.clientHeight;

    // Update camera
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 1000);
camera.position.set(0, 0, 0);
scene.add(camera);

// Controls
const controls = new OrbitControls(camera, canvas);
controls.target.set(0, 0.75, 0);

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    powerPreference: 'high-performance'
})

renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))



const tick = () =>
{
    controls.update()

    renderer.render(scene, camera)

    if (focusOnWindow) {
        window.requestAnimationFrame(tick);
    }
    
}

export const RENDERMETHOD = {
    scene: scene,
    camera: camera,
    renderer: renderer,
}

const renderOn = () => {
    controls.removeEventListener('change', renderOn)
    focusOnWindow = true;
    tick();
}

const renderOff = debounce(() => {
    focusOnWindow = false;
    controls.addEventListener('change', renderOn);
}, 1000)
controls.addEventListener('change', renderOff);

tick()